const MITRA_SEND_MONEY_URL = `${process.env.API_V4_HOST}/_exclusive/mitra-send-money`;

export const getMitraSendMoneyTransaction = ($axios, transactionId) =>
  $axios.$get(`${MITRA_SEND_MONEY_URL}/transaction/${transactionId}`);
